<template>
    <!--PC保养详情页-->
    <!-- 导航栏 -->
    <ZhaiHeadPC class="zhai-head"></ZhaiHeadPC>
    <!-- 导航栏 -->
    <!-- 主体内容容器 -->
    <div class="container errong">
        <div class="container-fluid p-0 my-2"></div>
        <div class="row gx-2">
            <!-- 左侧部分 -->
            <div class="col-lg-8">
                <div class="LeftPart">
                    <div class="row pp shengse pb-3 pt-1">
                        <div><span class="Title">{{ details.name }}</span></div>
                        <div class="ri mb-1">
                            <small class="bi bi-clock zitipc" id=""><span>&nbsp;{{ details.createTime.substr(0, 10) }}&nbsp;&nbsp;</span></small>
                            <small class="bi bi-person-fill zitipc" id="collect"><span>&nbsp;匿名</span></small>
                        </div>
                        <div class="daxiao">
                            <div class="py-1 jiushi"><span class="jiacu">地点：</span>&nbsp;{{ details.source }}</div>
                            <div class="py-1 jiushi"><span class="jiacu">年龄：</span>&nbsp;{{ details.age }}</div>
                            <div class="py-1 jiushi"><span class="jiacu">身高：</span>&nbsp;{{ details.height }}</div>
                            <div class="py-1 jiushi"><span class="jiacu">体重：</span>&nbsp;{{ details.weight }}</div>
                            <div class="py-1 jiushi"><span class="jiacu">职业：</span>&nbsp;{{ details.occupation }}</div>
                            <div class="mt-2">
                                <!-- 收藏按钮 -->
                                <button type="button" @click="toggleCollect" class="btn btn-outline-success bi-bag-heart jiushi me-2 button-large">
                                    {{ isCollected ? '已收藏' : '收藏' }}
                                </button>
                                <!-- 申请删除按钮 -->
                                <button type="button" @click="applyDel" class="btn btn-outline-success bi-trash3 jiushi button-large" data-bs-toggle="modal" data-bs-target="#myModal2">我要举报</button>
                            </div>
                        </div>
                    </div>

                    <!--商品-->
                    <div class="row shengse mt-2 rounded-top-1">
                        <div class="dixian px-4 py-2 d-flex justify-content-between">
                            <div><i class="shou bi bi-telephone-fill"></i>联系方式</div>
                            <div class="iden">
                                <a class="text-decoration-none ruhe zitiyanse hover-hand" @click="showModalInfo('myModal5')">如何鉴别？</a>
                            </div>
                        </div>
                    </div>
                    <!--商品-->
                    <!--如何鉴别-->
                    <div class="row shengse pt-4 pb-0">
                        <div class="px-4">
                            <div>
                                <div class="alert alert-warning zhuzi" role="alert">
                                    <span class="el-alert__title">
  给想包养的狼友们给出以下几点建议：<br>
1.女生如果问哪里看到的信息，请说是客服直接推荐的，尽量不要说是网址看到的，更不要截图给对方。因为很多女生不想照片被太多人看到，不愿把照片发到网上。但是为了方便会员，还是尽量能够把妹子资料介绍清楚，希望会员能够理解。<br>
2.比如有的女生说了只找本地的，请会员看清楚女生要求再加。如果有女生投诉故意骚扰的，我们会限制查看。请大家一起共同营造一个好的氛围，使寻欢阁平台能健康发展。谢谢!<br>
<br>
注意事项:<br>
1.切记不要提前给钱，不管是定金还是路费，都不要提前给钱。（这个是底线，请做一个有底线的男人）<br>
2.如果对方是外地的，可以先给对方订票，不要给定金或者路费。如果对方坚持要路费自己订票，那么99%是骗子，可以不用搭理了。（顺便再来帖子下方回复举报她一下）<br>
3.订票之前最好先视频确认一下，毕竟现在照片和本人有差距。<br>
4.到了之后，最好先在公共场所见面，先沟通一下。确定交往以后可以先付一部分费用，不要一次都给。<br>
5.月供可以分二次或者三次给，最好不要一次都给。避免给完钱对方提前走。<br>
6.在与女孩子沟通的时候一定要尊重别人，前期在不熟悉的情况下请不要上来就打听别人缺钱的原因。（每个人都有短期的困难需要资助）<br>
7.确定无误要在一起了，希望你能善待妹子，好好对她。
</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--如何鉴别-->
                    <!--账号-->
                    <div class="row shengse pb-4 rounded-bottom-1">
                        <div class="px-4">
                            <template v-if="!isLoggedIn">
                                <div class="py-1 jiushi">
                                    <span class="jiacu">QQ：</span>&nbsp;请先
                                    <router-link to="/login" class="login-register-link">登录</router-link>
                                    或
                                    <router-link to="/register" class="login-register-link">注册</router-link>
                                </div>
                                <div class="py-1 jiushi">
                                    <span class="jiacu">微信：</span>&nbsp;请先
                                    <router-link to="/login" class="login-register-link">登录</router-link>
                                    或
                                    <router-link to="/register" class="login-register-link">注册</router-link>
                                </div>
                                <div class="py-1 jiushi">
                                    <span class="jiacu">电话：</span>&nbsp;请先
                                    <router-link to="/login" class="login-register-link">登录</router-link>
                                    或
                                    <router-link to="/register" class="login-register-link">注册</router-link>
                                </div>
                            </template>

                            <template v-else-if="vipExpired">
                                <div class="py-1 jiushi">
                                    <span class="jiacu">QQ：</span>&nbsp;VIP可以无限制查看信息，请&nbsp;
                                    <router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link>
                                </div>
                                <div class="py-1 jiushi">
                                    <span class="jiacu">微信：</span>&nbsp;VIP可以无限制查看信息，请&nbsp;
                                    <router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link>
                                </div>
                                <div class="py-1 jiushi">
                                    <span class="jiacu">电话：</span>&nbsp;VIP可以无限制查看信息，请&nbsp;
                                    <router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link>
                                </div>
                            </template>

                            <template v-else-if="!isPermanentVip">
                                <div class="py-1 jiushi">
                                    <span class="jiacu">QQ：</span>&nbsp;包养信息仅限VIP永久会员可无限制查看，请
                                    <router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link>
                                </div>
                                <div class="py-1 jiushi">
                                    <span class="jiacu">微信：</span>&nbsp;包养信息仅限VIP永久会员可无限制查看，请
                                    <router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link>
                                </div>
                                <div class="py-1 jiushi">
                                    <span class="jiacu">电话：</span>&nbsp;包养信息仅限VIP永久会员可无限制查看，请
                                    <router-link to="/upgradeVIP" class="upgrade-vip-link">升级VIP</router-link>
                                </div>
                            </template>

                            <template v-else>
                                <div v-if="details.account" class="py-1 jiushi">
                                    <span class="jiacu">QQ：</span>&nbsp;{{ details.account }}
                                </div>
                                <div v-if="details.remark" class="py-1 jiushi">
                                    <span class="jiacu">微信：</span>&nbsp;{{ details.remark }}
                                </div>
                                <div v-if="details.phone" class="py-1 jiushi">
                                    <span class="jiacu">电话：</span>&nbsp;{{ details.phone }}
                                </div>
                            </template>

                            <div class="py-1 zhuzi">
                                <span style="color:red">！！！警告：凡是需要预先支付定金、路费的都是诈骗！任何情况下，都不要先给钱！</span>
                            </div>
                            <div class="mt-2">
                                <!-- 防骗指南按钮 -->
                                <button data-bs-toggle="modal" data-bs-target="#myModal4" type="button" href="" class="btn btn-outline-success bi-eye button-large">防骗指南</button>
                                <!-- 信息规则按钮 -->
                                <button data-bs-toggle="modal" data-bs-target="#myModal3" type="button" href="" class="btn btn-outline-success bi-info-circle button-large">信息规则</button>
                            </div>
                        </div>
                    </div>

                    <!--账号-->
                    <!--详细介绍-->
                    <div class="row shengse mt-2 rounded-top-1">
                        <div class="dixian px-4 py-2 d-flex justify-content-between">
                            <div class="deziti"><i class="shou bi bi-info-circle"></i>详细介绍</div>
                        </div>
                    </div>
                    <!--详细介绍-->
                    <!--截图-->
                    <div class="row shengse pb-4 rounded-bottom-1">
                        <div class="d-flex flex-wrap" ref="gallery">
                            <div class="p-2"
                                 v-for="(img, index) in imgList"
                                 :key="index"
                                 style="flex: 0 0 25%; max-width: 25%;">
                                <img
                                        class="Img w-100 clickable-img"
                                        :src="img"
                                        alt="图片预览"
                                        @click.stop.prevent="handleImageClick(index)"
                                />
                            </div>

                            <div class="px-3 pb-3 mt-3">
                                <p class="mb-2 indented" style="font-size: 0.9rem;">
                                    {{ details.history }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <!--截图-->
                </div>
            </div>
            <!-- 推荐部分 -->
            <div class="col-lg-4">
                <div class="RightPart">
                    <div class="bdcard">
                        <div class="row rr mt-4">
                            <div class="deziti zuo px-4 pb-2 d-flex justify-content-between">
                                <div><i class="shou bi bi-geo-alt-fill"></i>本地其他推荐</div>
                            </div>
                            <div v-for="(item, index) in recommendList" :key="index" class="no-underline mb-1">
                                <ZhaiCardPC :data="item" @click="updateRoute(item.id)"></ZhaiCardPC>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 主体内容容器 -->

    <!-- 只是占据空间 -->
    <div class="gongxi2"></div>

    <!-- 公共底部 -->
    <ZhaiFootPC></ZhaiFootPC>
    <!--申请删除  模态框 -->
    <div class="modal fade" id="myModal2">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <!-- 模态框头部 -->
                <div class="modal-header">
                    <h4 class="modal-title motou">我要举报</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <!-- 模态框内容 -->
                <div class="modal-body">
                    <div class="ant-modal-body motou px-3">
                        <div>本站所有內容来自网友分享，如有内容侵犯到你的隐私、权益或未经你的允许而被他人发布，平台很愿意为你删除，我们同样憎恶出于报复他人的目的而发布的内容。请你提供相关证明材料（比如与帖子内容相符的生活照、或你在其他社交平台发布的链接等，或可以证明联系方式确属于你的证明材料）发邮件至yufenglou123@gmail.com，我们通常会在24小时内处理你的请求，最长不会超过48小时，如果事实逻辑清晰我们将及时为你删除。</div>
                    </div>
                </div>
                <!-- 模态框底部 -->
                <div class="modal-footer di text-center">
                    <button type="button" class="btn btn-success toushu d-block mx-auto button-large2" data-bs-dismiss="modal">关闭</button>
                </div>
            </div>
        </div>
    </div>
    <!--信息规则 模态框 -->
    <div class="modal fade" id="myModal3">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <!-- 模态框头部 -->
                <div class="modal-header">
                    <h4 class="modal-title motou">信息规则</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <!-- 模态框内容 -->
                <div class="modal-body motou px-3">
                    <div>部分信息会隐藏具体地址和联系方式，需要升级VIP会员来享受无限制查看信息的权限。
                    </div>
                </div>
                <!-- 模态框底部 -->
                <div class="modal-footer di text-center">
                    <button type="button" class="btn btn-success toushu d-block mx-auto button-large2" data-bs-dismiss="modal">关闭</button>
                </div>
            </div>
        </div>
    </div>
    <!--防骗 模态框 -->
    <div class="modal fade" id="myModal4">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" style="margin-top: 380px;">
                <!-- 模态框头部 -->
                <div class="modal-header">
                    <h4 class="modal-title motou">防骗指南</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <!-- 模态框内容 -->
                <div class="modal-body p-2">
                    <p class="px-3 fb" style="margin-bottom: 0!important;">大家做到以下几点，基本可以有效避免上当受骗。</p>
                    <p class="px-3 fb">防骗第一条：凡是要求预付定金/保证金的，都是骗子！</p>
                    <p class="px-3 motou">
                        一、如果妹子是自己租公寓或者小区里的房子，打听一下房子的租金就可以知道妹子做这个生意的成本大概是多少，依据这个可判断是不是坑。不熟悉的妹子千万不要选择上门，因为没有自己承租地方做这个生意的，大概率都是骗子。
                    </p>
                    <p class="px-3 motou">
                        二、未见面，拒绝提前支付任何费用！！！如车费、定金、安全保证金、预付一半费用、付全款后才见面等各种理由的费用（如给红包发照片，给红包视频，定位到楼下付款，其他人代收款等），切勿因为已开房或其他费用，因小失大，不停给对方打款，越陷越深。
                    </p>
                    <p class="px-3 motou">
                        三、见面后，确认为所预约的人，付费给妹子，或当着妹子的面付给中间人，付费后禁止对方以任何理由离开房间，如有必要离开，请随行，或要求对方退款后，方可离开。
                    </p>
                    <p class="px-3 motou">
                        四、见面后，人照不符的，不满意的，可以拒绝接受服务，或给车费让他走。如是平台认证的帖子，差距大的，不满意的，请立即联系管理员处理。并及时联系平台在线客服。
                    </p>
                    <p class="px-3 motou">
                        五、到店服务的，和描述不一致，直接离开。进店后，问清楚服务项目。确认有服务，选到满意技师，再交费或服务后再交费。模糊介绍服务，为选人先交费，要求办卡才有服务的，请立即离开，并联系平台反馈。
                    </p>
                    <p class="px-3 motou">
                        六、可以提前百度一下对方的联系方式，看是否有人曾被骗。
                    </p>
                    <p class="px-3 motou">
                        七、拒绝支付任何平台旗号的费用。
                    </p>

                </div>
                <!-- 模态框底部 -->
                <div class="modal-footer di text-center">
                    <button type="button" class="btn btn-success toushu d-block mx-auto button-large2" data-bs-dismiss="modal">关闭</button>
                </div>
            </div>
        </div>
    </div>
    <!--如何鉴别 模态框 -->
    <div class="modal fade" id="myModal5">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <!-- 模态框头部 -->
                <div class="modal-header">
                    <h4 class="modal-title">如何鉴别</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <!-- 模态框内容 -->
                <div class="modal-body p-2">
                    当您对账号的质量有所顾虑的时候，建议您先购买季度会员，找到适合您的账号并且感觉
                    本站产品的质量可以的情况下再进行VIP升级；
                </div>
                <!-- 模态框底部 -->
                <div class="modal-footer mt-2 text-center" style="display: block;">
                    <div class="row">
                        <div class="col-6">
                            <button type="button" class="btn btn-success toushu button-large" data-bs-dismiss="modal">关闭</button>
                        </div>
                        <div class="col-6">
                            <button
                                    type="button"
                                    class="btn btn-success toushu button-large2"
                                    @click="handleNavigateToAvoidFraud">
                                新手防骗指南
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 登录警示 模态框 -->
    <div class="modal fade" id="loginWarningModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="width: 150px;">
            <div class="modal-content">
                <div class="modal-body text-center d-flex align-items-center justify-content-center">
                    <i class="bi bi-emoji-frown" style="font-size: 2rem; color: #f16b6b;"></i>
                    <p class="mb-0 ms-2" style="font-size: 1rem; color: #f16b6b;">请先登录！</p>
                </div>
            </div>
        </div>
    </div>
    <!-- 成功模态框 -->
    <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 200px;">
            <div class="modal-content">
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <i class="bi bi-emoji-smile" style="font-size: 2rem; color: #00c26f;"></i>
                    <p class="mb-0 ms-2" style="font-size: 1rem; color: #00c26f;"></p>
                </div>
            </div>
        </div>
    </div>

    <!-- 失败模态框 -->
    <div class="modal fade" id="generalErrorModal" tabindex="-1" aria-labelledby="errorModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-shake" style="max-width: 200px;">
            <div class="modal-content shake">
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <i class="bi bi-emoji-frown" style="font-size: 2rem; color: #dc3545;"></i>
                    <p class="mb-0 ms-2" style="font-size: 1rem; color: #dc3545;"></p>
                </div>
            </div>
        </div>
    </div>
    <!-- 图片放大权限提示 -->
    <div class="modal fade" id="imageVipModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 320px;">
            <div class="modal-content">
                <div class="modal-body text-center py-4">
                    <i class="bi bi-images" style="font-size: 2rem; color: #00c26f;"></i>
                    <p class="mt-3 mb-3" style="font-size: 1rem; color: #333;">
                        仅VIP会员可使用图片放大功能，请升级VIP会员。
                    </p>
                    <button
                            type="button"
                            class="btn btn-success button-large2"
                            data-bs-dismiss="modal"
                            @click="$router.push('/upgradeVIP')">
                        去升级
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Viewer from 'viewerjs';
    import 'viewerjs/dist/viewer.css';
    import { Modal } from 'bootstrap';
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import ZhaiCardPC from "../componentspc/ZhaiCardPC";
    import http from "../utils/http.js";
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: "PDetails3",
        components: {
            ZhaiHeadPC,
            ZhaiFootPC,
            ZhaiCardPC
        },
        props: ['id'],
        data() {
            return {
                details: {
                    name: '',
                    uploadDate: '',
                    collection: '',
                    province: '',
                    city: '',
                    age: '',
                    price: '',
                    level: '',
                    condition: '',
                    account: '',
                    remark: '',
                    email: '',
                    attention: '',
                    phone: '',
                    source: '',
                    img: '',
                    createTime: '',
                    history: '',
                    presets3: '',
                    presets4: '',
                    presets5: '',
                    occupation:''
                },
                imgList: [],
                recommendList: [],
                isCollected: false,
                viewerInstance: null
            };
        },
        computed: {
            ...mapGetters(['isLoggedIn', 'getUser']),

            vipExpired() {
                if (!this.isLoggedIn) return false;
                if (!this.getUser) return false;

                const raw =
                    this.getUser.level_expire_date ??
                    this.getUser.levelExpireDate ??
                    this.getUser.level_expireDate ??
                    null;

                if (raw === null || raw === undefined) return true;

                const trimmed = String(raw).trim();
                if (trimmed === "" || trimmed === "null" || trimmed === "undefined") return true;

                if (!Number.isNaN(Number(trimmed))) {
                    const n = Number(trimmed);
                    const ms = String(Math.trunc(n)).length === 10 ? n * 1000 : n;
                    return ms < Date.now();
                }

                let s = trimmed;
                s = s.replace(' ', 'T');
                s = s.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');

                if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
                    s += 'T23:59:59';
                }

                const d = new Date(s);
                const ms = d.getTime();
                if (Number.isNaN(ms)) {
                    console.warn('VIP expire date parse failed:', raw, 'normalized=', s);
                    return true;
                }

                return ms < Date.now();
            },

            isPermanentVip() {
                if (!this.isLoggedIn) return false;

                const level = String(this.getUser?.level || "").trim();
                if (!level || level === "null" || level === "undefined") return false;

                return level.includes("永久会员");
            },

            canViewMaintainContact() {
                return this.isLoggedIn && !this.vipExpired && this.isPermanentVip;
            },
            // 非会员图片限制放大
            canZoomImages() {
                if (!this.isLoggedIn || !this.getUser) return false;

                const level = String(this.getUser?.level || "").trim();
                if (!level || level === "null" || level === "undefined") return false;

                const isVipLevel =
                    level.includes("月度会员") ||
                    level.includes("季度会员") ||
                    level.includes("年度会员") ||
                    level.includes("永久会员");

                if (!isVipLevel) return false;

                if (level.includes("永久会员")) return true;

                return !this.vipExpired;
            }

        },
        async created() {
            // ✅ 关键：先等 store 把 user 补齐（避免首屏误判 vipExpired）
            await this.checkLoginStatus();

            this.fetchDetails();
            this.checkCollectStatus();
        },

        mounted() {
            this.initViewer();
        },

        watch: {
            imgList() {
                this.initViewer();
            },
            '$route.query.id'() {
                this.isCollected = false;
                this.fetchDetails();
                this.checkCollectStatus();
            }

        },

        methods: {
            ...mapActions(['logout', 'checkLoginStatus']),

            handleNavigateToAvoidFraud() {
                const modal5 = document.getElementById('myModal5');
                if (modal5) {
                    const modalInstance = Modal.getInstance(modal5);
                    if (modalInstance) modalInstance.hide();

                    document.body.classList.remove('modal-open');
                    const backdrops = document.getElementsByClassName('modal-backdrop');
                    while (backdrops.length > 0) {
                        backdrops[0].parentNode.removeChild(backdrops[0]);
                    }
                }
                this.$nextTick(() => {
                    this.$router.push('/avoidFraud');
                });
            },

            updateRoute(id) {
                this.$router.push({ query: { id } });
            },

            showModalInfo(modalId) {
                const modalElement = document.getElementById(modalId);
                if (modalElement) {
                    const modal = new Modal(modalElement);
                    modal.show();
                }
            },

            applyDel() {
                console.log('申请删除按钮被点击');
            },
            checkCollectStatus() {
                if (!this.isLoggedIn || !this.getUser?.id) return;

                // ✅ 关键：路由 query 一定是字符串，必须转数字
                const accountId = Number(this.$route.query.id);
                const userId = Number(this.getUser.id);

                if (!accountId || !userId) return;

                const postData = {
                    accountid: accountId,
                    userid: userId,
                    action: 'check'
                };

                http.post('/platform/frontEnd/handleCollect3', postData)
                    .then(response => {
                        if (response.data.status === 1) {
                            this.isCollected = !!response.data.data.isCollected;
                        } else {
                            console.error('检查收藏状态失败:', response.data.msg);
                        }
                    })
                    .catch(err => {
                        console.error('检查收藏状态请求异常:', err);
                    });
            },
            toggleCollect() {
                if (!this.isLoggedIn) {
                    const warningModalElement = document.getElementById('loginWarningModal');
                    const warningModal = new Modal(warningModalElement);

                    if (warningModalElement.classList.contains('show')) {
                        warningModalElement.classList.remove('shake-animation');
                        void warningModalElement.offsetWidth;
                        warningModalElement.classList.add('shake-animation');
                    } else {
                        warningModalElement.classList.add('shake-animation');
                        warningModal.show();
                        setTimeout(() => warningModal.hide(), 2000);
                        setTimeout(() => warningModalElement.classList.remove('shake-animation'), 600);
                    }
                    return;
                }

                const accountId = Number(this.details.id || this.$route.query.id);
                const userId = Number(this.getUser.id);
                const action = this.isCollected ? 'cancel' : 'collect';

                if (!userId || !accountId) return;

                const postData = {
                    accountid: accountId,
                    userid: userId,
                    action
                };

                http.post('/platform/frontEnd/handleCollect3', postData)
                    .then(response => {
                        if (response.data && response.data.status === 1) {
                            this.isCollected = !this.isCollected;
                            this.showModal(
                                'successModal',
                                this.isCollected ? '收藏成功' : '取消收藏成功',
                                'bi bi-emoji-smile',
                                '#00c26f'
                            );
                        } else {
                            this.showModal(
                                'generalErrorModal',
                                action === 'collect' ? '收藏失败' : '取消收藏失败',
                                'bi bi-emoji-frown',
                                '#dc3545'
                            );
                        }
                    })
                    .catch(error => {
                        console.error(`${action === 'collect' ? '收藏' : '取消收藏'}请求错误:`, error);
                        this.showModal('generalErrorModal', '请求发生错误，请稍后再试', 'bi bi-emoji-frown', '#dc3545');
                    });
            },



            showModal(modalId, message, iconClass, textColor) {
                const modalElement = document.getElementById(modalId);
                const modalBodyP = modalElement.querySelector('.modal-body p');
                const icon = modalElement.querySelector('.bi');

                icon.className = iconClass;
                icon.style.color = textColor;
                modalBodyP.textContent = message;

                const modal = new Modal(modalElement);
                modalElement.classList.add('shake-animation');
                modal.show();

                setTimeout(() => {
                    modalElement.classList.remove('shake-animation');
                    modal.hide();
                }, 3000);
            },

            initViewer() {
                this.$nextTick(() => {
                    const gallery = this.$refs.gallery;
                    if (gallery) {
                        if (this.viewerInstance) this.viewerInstance.destroy();
                        this.viewerInstance = new Viewer(gallery, {
                            url(image) {
                                return image.src;
                            }
                        });
                    }
                });
            },

            fetchDetails() {
                const id = this.$route.query.id;
                if (!id) return;

                http.get(`/platform/frontEnd/details3?id=${id}`)
                    .then(response => {
                        if (response.data.status === 1) {
                            this.details = response.data.data;

                            this.imgList = [
                                ...(this.details.img ? this.details.img.split(',').map(v => v.trim()) : []),
                                ...(this.details.presets3 ? this.details.presets3.split(',').map(v => v.trim()) : []),
                                ...(this.details.presets4 ? this.details.presets4.split(',').map(v => v.trim()) : []),
                                ...(this.details.presets5 ? this.details.presets5.split(',').map(v => v.trim()) : [])
                            ];

                            this.checkCollectStatus();
                            this.fetchRecommendList(this.details.id);
                        } else {
                            console.error('获取详情数据失败:', response.data.msg);
                        }
                    })
                    .catch(error => {
                        console.error('获取详情数据时出错:', error);
                    });
            },

            fetchRecommendList(id) {
                if (!id) return;

                http.get(`/platform/frontEnd/recommendList3?id=${id}`)
                    .then(response => {
                        if (response.data.status === 1) {
                            this.recommendList = response.data.data || [];
                        } else {
                            console.error('获取推荐列表失败:', response.data.msg);
                        }
                    })
                    .catch(error => {
                        console.error('获取推荐列表时出错:', error);
                    });
            },
            // 图片放大权限
            handleImageClick(index) {
                if (!this.canZoomImages) {
                    const modalElement = document.getElementById('imageVipModal');
                    if (modalElement) {
                        const modal = new Modal(modalElement);
                        modal.show();
                    }
                    return;
                }

                if (this.viewerInstance) {
                    this.viewerInstance.view(index);
                }
            }

        }
    };
</script>

<style scoped>
    .fb{
        font-weight: bold;
        color: #00c26f

    }
    .motou{
        font-size: 1rem!important;
    }
    .gongxi2 {
        height: 20px;
    }

    .errong {
        padding-left: 30px;
        padding-right: 30px;
    }

    .card-body > p {
        margin-bottom: 0 !important;
    }

    .container {
        padding-left: 20px;
        padding-right: 20px;
    }

    .LeftPart {
        margin-top: 10px;
    }

    /*模态框按钮颜色以及去边框*/
    .toushu {
        background-color: #00c26f !important;
        border: none !important;
    }

    .btn {
        font-size: 0.6rem;
        padding: 0.2rem 0.5rem;
        line-height: 1.5;
    }

    .btn-outline-success {
        color: #00c26f;
        border-color: #00c26f;
    }

    .me-2 {
        margin-right: 0.5rem;
    }

    .pp {
        padding-left: 0.8rem !important;
        padding-right: 0 !important;
        border-radius: 2px;
    }

    .col-lg-4 {
        margin-left: 20px;
    }

    .col-lg-8 {
        width: calc(100% - 20px - 33.333333%);
    }

    .zuo {
        padding-left: 10px !important;
    }

    .shou {
        font-style: normal;
    }

    .zhuzi {
        font-size: 0.8rem;
    }

    .jiushi {
        font-size: 0.9rem;
    }

    .indented {
        text-indent: 2em;
    }
    .bi-bag-heart {
        margin-right: 5px;
    }

    .bi-eye {
        margin-right: 5px;
    }

    .ruhe {
        font-size: 0.6rem;
    }

    .bi-telephone-fill {
        font-size: 10px;
    }

    h4 {
        font-size: 0.8rem !important;
    }
    .modal-dialog {
        width: 40%;
        max-height: 50%;
        margin: auto;
    }

    .modal-body {
        padding: 0;
    }

    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem;
        border-bottom: 1px solid #dee2e6;
    }

    .modal-content {
        position: relative;
        background-color: white;
        border: 1px solid #dee2e6;
        margin: auto;
    }

    .modal-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
        transition: transform 0.2s ease;
        cursor: grab;
    }

    .modal-image:active {
        cursor: grabbing;
    }

    .outside-close {
        position: fixed;
        top: 10px;
        right: 10px;
        background-color: rgba(255, 255, 255, 0.3);
        border: none;
        font-size: 1rem;
        cursor: pointer;
        z-index: 1051;
        opacity: 0.7;
    }

    .outside-close:hover {
        opacity: 1;
    }

    .modal-controls {
        position: fixed;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 10px;
        z-index: 1051;
    }

    .btn-control {
        background-color: transparent;
        border: none;
        font-size: 1.5rem;
        opacity: 0.7;
        color: white;
    }

    .btn-control:hover {
        opacity: 1;
    }

    .rounded-top-2 {
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;
    }

    .rounded-bottom-2 {
        border-bottom-left-radius: 2px;
        border-bottom-right-radius: 2px;
    }

    .login-register-link {
        color: #18b371 !important;
        font-size: inherit;
        text-decoration: none;
        padding: 0;
    }

    .login-register-link:hover {
        text-decoration: underline;
    }

    @keyframes shake {
        0%, 100% {
            transform: translateX(0);
        }
        10%, 30%, 50%, 70%, 90% {
            transform: translateX(-10px);
        }
        20%, 40%, 60%, 80% {
            transform: translateX(10px);
        }
    }

    .shake-animation {
        animation: shake 0.5s;
    }

    /*四大按钮的字体大小和内边距*/
    .button-large {
        padding: 0.3rem 0.7rem;
        font-size: 0.9rem !important;
    }
    .button-large2{
        padding: 0.3rem 0.7rem;
        font-size: 1rem !important;
    }

    .ZhaiCardPC {
        --bs-gutter-x: 0!important;
    }

    .rr {
        --bs-gutter-x: 1.5rem!important;
    }

    @keyframes shake {
        0%, 100% {
            transform: translateX(0);
        }
        10%, 30%, 50%, 70%, 90% {
            transform: translateX(-2px);
        }
        20%, 40%, 60%, 80% {
            transform: translateX(2px);
        }
    }

    .shake-animation {
        animation: shake 0.5s;
    }

    .hover-hand {
        cursor: pointer;
    }

    /* 调整模态框垂直居中并向上偏移 */
    .modal-dialog-centered {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100vh; /* 保持模态框在视口中垂直居中 */
    }

    .modal-content {
        margin: auto;
        transform: translateY(-45%); /* 将模态框向上移动20% */
    }

    .upgrade-vip-link {
        color: #00c26f !important;
        font-size: inherit;
        text-decoration: none;
        cursor: pointer;
    }

    .upgrade-vip-link:hover {
        text-decoration: underline;
    }



</style>
